import ComingSoonPage from "../shared/pages/ComingSoonPage";

export const comingSoonRoutes = [
  // Membership
  {
    path: "/membership/members",
    element: <ComingSoonPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },
  {
    path: "/membership/approvals",
    element: <ComingSoonPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },

  // Training
  {
    path: "/training/programs",
    element: <ComingSoonPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },
  {
    path: "/training/my",
    element: <ComingSoonPage />,
    roles: ["member", "probationer"],
  },

  // Finance
  {
    path: "/finance",
    element: <ComingSoonPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },
  {
    path: "/finance/reports",
    element: <ComingSoonPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },

  // Chapter / Zone
  {
    path: "/chapters",
    element: <ComingSoonPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },
  {
    path: "/certificates",
    element: <ComingSoonPage />,
  },
  {
    path: "/cpds",
    element: <ComingSoonPage />,
  },
  {
    path: "/chapters/leadership",
    element: <ComingSoonPage />,
    roles: ["admin", "chairman", "secretary"],
  },

  // Access Control

  {
    path: "/access/permissions",
    element: <ComingSoonPage />,
    roles: ["admin"],
  },
];
